import { render, staticRenderFns } from "./WidgetDropzone.vue?vue&type=template&id=4617a370&scoped=true"
import script from "./WidgetDropzone.vue?vue&type=script&lang=js"
export * from "./WidgetDropzone.vue?vue&type=script&lang=js"
import style0 from "./WidgetDropzone.vue?vue&type=style&index=0&id=4617a370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4617a370",
  null
  
)

export default component.exports